import { APICfg } from 'services/api/api'
import {
  APIOptionedPackage,
  OptionedPackage,
  optionedPackageWrite,
  optionedPresetParse,
} from './common'

const apiCfg: APICfg = {
  endpoint: 'physicalpackage',
  parse: (req: APIOptionedPackage): OptionedPackage => ({
    ...req,
    products: req.products.map(optionedPresetParse),
  }),
  write: async (req: OptionedPackage): Promise<OptionedPackage> =>
    optionedPackageWrite(req),
}

export default apiCfg
